//登录模块
import { makeAutoObservable, runInAction, toJS } from "mobx"
import { makePersistable } from 'mobx-persist-store'
import { http, setToken, getToken, removeToken } from '@/utils'
import { message } from 'antd'

import { menu, topnav } from "@/mock/loginMenu"


class LoginStore {
    // 1.定义数据
    token = getToken() || ''
    //验证码
    captcha = ''
    //勾选
    remember = false
    username = ''
    password = ''
    //左侧菜单栏
    menuList = []
    //上部导航
    topNavList = []
    //isActive
    isActive = false
    //权限
    item = {}
    //合作社名
    hzsname = ''
    //合作社id
    hzsid = ''
    // 2.把数据变成响应式
    constructor() {
        makeAutoObservable(this)
        //持久化存储
        makePersistable(this,
            {
                name: 'mobxMeniuLst',
                properties: ['menuList'],
                storage: window.localStorage,
            }
        )
        makePersistable(this,
            {
                name: 'mobxUsername',
                properties: ['username'],
                storage: window.localStorage,
            }
        )
        makePersistable(this,
            {
                name: 'mobxPssword',
                properties: ['password'],
                storage: window.localStorage,
            }
        )
        makePersistable(this,
            {
                name: 'mobxRemember',
                properties: ['remember'],
                storage: window.localStorage,
            }
        )
        makePersistable(this,
            {
                name: 'mobxTopNavList',
                properties: ['topNavList'],
                storage: window.localStorage,
            }
        )
        makePersistable(this,
            {
                name: 'mobxItem',
                properties: ['item'],
                storage: window.localStorage,
            }
        )
        makePersistable(this,
            {
                name: 'hzsname',
                properties: ['hzsname'],
                storage: window.localStorage,
            }
        )
        makePersistable(this,
            {
                name: 'hzsid',
                properties: ['hzsid'],
                storage: window.localStorage,
            }
        )
    }
    //登录接口
    getToken = async (values) => {
        if (this.captcha.toLowerCase() === values.code.toLowerCase()) {
            const relult = await http.post('/coopapi/login/login', values)
            if (relult.data.code === 200) {
                runInAction(() => {
                    this.token = relult.data.data.apitoken
                    const rules = JSON.parse(toJS(relult.data.data.rules))
                    console.log(rules, 'rules')
                    // this.menuList = rules.menu
                    this.topNavList = topnav
                    this.menuList = menu
                    this.hzsid = relult.data.data.id
                    this.hzsname = relult.data.data.nickname
                })
                window.location.href = '/'
                console.log(toJS(this.topNavList), "this.topNavList")
                setToken(this.token)
            } else {
                message.error(relult.data.msg)
            }
        } else {
            message.error('验证码错误')
        }
    }



    //退出登录 删除token
    loginOut = () => {
        this.token = ''
        removeToken()
        if (this.remember === false) {
            this.password = ''
        }
    }
}

// 实例化，导出给react 使用
export { LoginStore }